import ReactGA from 'react-ga4';

const GA4_MEASUREMENT_ID = 'G-E4JME56MQM'; 

ReactGA.initialize(GA4_MEASUREMENT_ID, {
  debug: process.env.NODE_ENV !== 'production',
  gadev: true, 
});

export default ReactGA;